import type { AvatarDesignTokens } from '@adsk/alloy-react-styles';
import { StyleProp } from '@adsk/alloy-react-theme';

/**
 * Map the base avatar tokens to camelCase css.
 *
 * The tokens are kebab-cased, but styled-components only recognises a property
 * as unitless when it is written camelCase: spread as-is, a numeric
 * `'font-weight': 500` is serialised to `font-weight: 500px`, which the browser
 * drops, and the initials fall back to the inherited weight. Same reasoning as
 * `activityLogTextCss` in ActivityLog.
 */
export const avatarBaseCss = (tokens?: AvatarDesignTokens['_']): StyleProp => ({
  borderRadius: tokens?.['border-radius'],
  borderWidth: tokens?.['border-width'],
  borderStyle: tokens?.['border-style'],
  fontFamily: tokens?.['font-family'],
  fontWeight: tokens?.['font-weight'],
});
